<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Evaluaciones Psicológicas
        </div>
        <template v-if="perfil !== 'Antecedentes' && perfil !== 'Validación'">
          <v-row v-if="psicologica.length > 0">
            <v-col
              v-for="(evaluacionPsicologica, index) in psicologica"
              :key="index"
              cols="3"
            >
              <v-card color="secondary">
                <v-card-title
                  v-if="evaluacionPsicologica.CatSemaforoResultado"
                  class="d-block"
                  align="center"
                >
                  <v-avatar
                    :color="evaluacionPsicologica.CatSemaforoResultado.colorSemaforo"
                    size="48"
                    class="mb-4 blink"
                  />
                  <div class="body-2 primary--text font-weight-bold">
                    {{ evaluacionPsicologica.CatSemaforoResultado.nombre }}
                  </div>
                </v-card-title>
                <v-card-title class="d-inline-block">
                  <div class="text-caption white--text">
                    Oficio de solicitud
                  </div>
                  <div class="text-h6 white--text">
                    {{ evaluacionPsicologica.Derivacion.oficioSolicitud }}
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="text-caption white--text">
                    Acerca de la evaluación
                  </div>
                  <div class="text-body-2 white--text">
                    Evaluación realizada el
                    {{ evaluacionPsicologica.Derivacion.fechaOficioSolicitud }} por
                    {{ evaluacionPsicologica.CatEvaluador.evaluador }}
                  </div>
                  <div class="text-caption white--text mt-4">
                    Diagnóstico
                  </div>
                  <div
                    v-if="evaluacionPsicologica.CatDiagnostico"
                    class="text-body-2 white--text"
                  >
                    {{ evaluacionPsicologica.CatDiagnostico.title }}
                  </div>
                </v-card-text>
                <v-card-actions v-if="perfil === 'Psicología' || perfil === 'Integración'">
                  <v-spacer />
                  <v-btn
                    v-if="verifyArchivosDerivacion(evaluacionPsicologica.Derivacion)"
                    icon
                    color="white"
                    @click="downloadArchivosDerivacion(evaluacionPsicologica.Derivacion)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <formato-psicologico-component :evaluacion="evaluacionPsicologica" />
                  <v-btn
                    icon
                    color="white"
                  >
                    <v-icon @click="openEvaluacionPsicologicaDialog(evaluacionPsicologica)">
                      mdi-file-document
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <div class="text-h6">
                No hay evaluaciones psicológicas registradas.
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col>
              <v-alert
                border="left"
                color="secondary"
                class="white--text"
              >
                No tiene permisos para ver esta información.
              </v-alert>
            </v-col>
          </v-row>
        </template>
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Evaluaciones Poligráficas
        </div>
        <template v-if="perfil !== 'Antecedentes' && perfil !== 'Validación'">
          <v-row v-if="poligrafica.length > 0">
            <v-col
              v-for="(evaluacionPoligrafica, index) in poligrafica"
              :key="index"
              cols="3"
            >
              <v-card color="secondary">
                <v-card-title
                  v-if="evaluacionPoligrafica.CatSemaforoResultado"
                  class="d-block"
                  align="center"
                >
                  <v-avatar
                    :color="evaluacionPoligrafica.CatSemaforoResultado.colorSemaforo"
                    size="48"
                    class="mb-4 blink"
                  />
                  <div class="body-2 primary--text font-weight-bold">
                    {{ evaluacionPoligrafica.CatSemaforoResultado.nombre }}
                  </div>
                </v-card-title>
                <v-card-title class="d-inline-block">
                  <div class="text-caption white--text">
                    Oficio de solicitud
                  </div>
                  <div class="text-h6 white--text">
                    {{ evaluacionPoligrafica.Derivacion.oficioSolicitud }}
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="text-caption white--text">
                    Acerca de la evaluación
                  </div>
                  <div class="text-body-2 white--text">
                    Evaluación realizada el
                    {{ evaluacionPoligrafica.Derivacion.fechaOficioSolicitud }} por
                    {{ evaluacionPoligrafica.CatEvaluadorElaboro.evaluador }}
                  </div>
                  <div class="text-body-2 white--text">
                    Revisada por {{ evaluacionPoligrafica.evaluadorReviso }}
                  </div>
                </v-card-text>
                <v-card-actions v-if="perfil === 'Poligrafía' || perfil === 'Integración'">
                  <v-spacer />
                  <v-btn
                    v-if="verifyArchivosDerivacion(evaluacionPoligrafica.Derivacion)"
                    icon
                    color="white"
                    @click="downloadArchivosDerivacion(evaluacionPoligrafica.Derivacion)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <formato-poligrafo-component :evaluacion="evaluacionPoligrafica" />
                  <v-btn
                    icon
                    color="white"
                  >
                    <v-icon @click="openEvaluacionPoligraficaDialog(evaluacionPoligrafica)">
                      mdi-file-document
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <div class="text-h6">
                No hay evaluaciones poligráficas registradas.
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col>
              <v-alert
                border="left"
                color="secondary"
                class="white--text"
              >
                No tiene permisos para ver esta información.
              </v-alert>
            </v-col>
          </v-row>
        </template>
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Evaluaciones Médicas
        </div>
        <template v-if="perfil !== 'Antecedentes' && perfil !== 'Validación'">
          <v-row v-if="medico.length > 0">
            <v-col
              v-for="(evaluacionMedica, index) in medico"
              :key="index"
              cols="3"
            >
              <v-card color="secondary">
                <v-card-title
                  v-if="evaluacionMedica.CatSemaforoResultado"
                  class="d-block"
                  align="center"
                >
                  <v-avatar
                    :color="evaluacionMedica.CatSemaforoResultado.colorSemaforo"
                    size="48"
                    class="mb-4 blink"
                  />
                  <div class="body-2 primary--text font-weight-bold">
                    {{ evaluacionMedica.CatSemaforoResultado.nombre }}
                  </div>
                </v-card-title>
                <v-card-title class="d-inline-block">
                  <div class="text-caption white--text">
                    Oficio de solicitud
                  </div>
                  <div class="text-h6 white--text">
                    {{ evaluacionMedica.Derivacion.oficioSolicitud }}
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="text-caption white--text">
                    Acerca de la evaluación
                  </div>
                  <div class="text-body-2 white--text">
                    Evaluación realizada el
                    {{ evaluacionMedica.Derivacion.fechaOficioSolicitud }} por
                  </div>
                  <div class="text-caption white--text mt-4">
                    Observaciones
                  </div>
                  <div class="text-body-2 white--text">
                    {{ evaluacionMedica.observaciones }}
                  </div>
                </v-card-text>
                <v-card-actions v-if="perfil === 'Médico' || perfil === 'Integración'">
                  <v-spacer />
                  <v-btn
                    v-if="verifyArchivosDerivacion(evaluacionMedica.Derivacion)"
                    icon
                    color="white"
                    @click="downloadArchivosDerivacion(evaluacionMedica.Derivacion)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <formato-medico-component :evaluacion="evaluacionMedica" />
                  <v-btn
                    icon
                    color="white"
                    @click="openEvaluacionMedicaDialog(evaluacionMedica)"
                  >
                    <v-icon>mdi-file-document</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <div class="text-h6">
                No hay evaluaciones médicas registradas.
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col>
              <v-alert
                border="left"
                color="secondary"
                class="white--text"
              >
                No tiene permisos para ver esta información.
              </v-alert>
            </v-col>
          </v-row>
        </template>
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Evaluaciones Validación
        </div>
        <template v-if="perfil !== 'Antecedentes'">
          <v-row v-if="validacion.length > 0">
            <v-col
              v-for="(evaluacionValidacion, index) in validacion"
              :key="index"
              cols="3"
            >
              <v-card color="secondary">
                <v-card-title
                  v-if="evaluacionValidacion.CatSemaforoResultado"
                  class="d-block"
                  align="center"
                >
                  <v-avatar
                    :color="evaluacionValidacion.CatSemaforoResultado.colorSemaforo"
                    size="48"
                    class="mb-4 blink"
                  />
                  <div class="body-2 primary--text font-weight-bold">
                    {{ evaluacionValidacion.CatSemaforoResultado.nombre }}
                  </div>
                </v-card-title>
                <v-card-title class="d-inline-block">
                  <div class="text-caption white--text">
                    Oficio de solicitud
                  </div>
                  <div class="text-h6 white--text">
                    {{ evaluacionValidacion.Derivacion.oficioSolicitud }}
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="text-caption white--text mt-4">
                    Resultado
                  </div>
                  <div class="text-body-2 white--text">
                    {{ evaluacionValidacion.resultado }}
                  </div>
                </v-card-text>
                <v-card-actions v-if="perfil === 'Validación' || perfil === 'Integración'">
                  <v-spacer />
                  <v-btn
                    v-if="verifyArchivosDerivacion(evaluacionValidacion.Derivacion)"
                    icon
                    color="white"
                    @click="downloadArchivosDerivacion(evaluacionValidacion.Derivacion)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <formato-validacion-component :evaluacion="evaluacionValidacion" />
                  <v-btn
                    icon
                    color="white"
                    @click="openEvaluacionValidacionDialog(evaluacionValidacion)"
                  >
                    <v-icon>mdi-file-document</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <div class="text-h6">
                No hay evaluaciones de validación registradas.
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col>
              <v-alert
                border="left"
                color="secondary"
                class="white--text"
              >
                No tiene permisos para ver esta información.
              </v-alert>
            </v-col>
          </v-row>
        </template>
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Evaluaciones ISE
        </div>
        <template v-if="perfil !== 'Antecedentes' && perfil !== 'Validación'">
          <v-row v-if="ise.length > 0">
            <v-col
              v-for="(evaluacionIse, index) in ise"
              :key="index"
              cols="3"
            >
              <v-card color="secondary">
                <v-card-title
                  v-if="evaluacionIse.CatSemaforoResultado"
                  class="d-block"
                  align="center"
                >
                  <v-avatar
                    :color="evaluacionIse.CatSemaforoResultado.colorSemaforo"
                    size="48"
                    class="mb-4 blink"
                  />
                  <div class="body-2 primary--text font-weight-bold">
                    {{ evaluacionIse.CatSemaforoResultado.nombre }}
                  </div>
                </v-card-title>
                <v-card-title class="d-inline-block">
                  <div class="text-caption white--text">
                    Oficio de solicitud
                  </div>
                  <div class="text-h6 white--text">
                    {{ evaluacionIse.Derivacion.oficioSolicitud }}
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="text-caption white--text">
                    Acerca de la evaluación
                  </div>
                  <div class="text-body-2 white--text">
                    Evaluación realizada el {{ evaluacionIse.Derivacion.fechaOficioSolicitud }} por
                    {{ evaluacionIse.CatEvaluador.evaluador }}
                  </div>
                  <div class="text-caption white--text mt-4">
                    Diagnóstico
                  </div>
                  <div class="text-body-2 white--text">
                    {{ evaluacionIse.CatDiagnostico.title }}
                  </div>
                </v-card-text>
                <v-card-actions v-if="perfil === 'ISE' || perfil === 'Integración'">
                  <v-spacer />
                  <v-btn
                    v-if="verifyArchivosDerivacion(evaluacionIse.Derivacion)"
                    icon
                    color="white"
                    @click="downloadArchivosDerivacion(evaluacionIse.Derivacion)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <formato-ise-component :evaluacion="evaluacionIse" />
                  <v-btn
                    icon
                    color="white"
                  >
                    <v-icon @click="openEstatusEvaluacionIseDialog(evaluacionIse)">
                      mdi-update
                    </v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="white"
                  >
                    <v-icon @click="openEvaluacionIseDialog(evaluacionIse)">
                      mdi-file-document
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <div class="text-h6">
                No hay evaluaciones ISE registradas.
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col>
              <v-alert
                border="left"
                color="secondary"
                class="white--text"
              >
                No tiene permisos para ver esta información.
              </v-alert>
            </v-col>
          </v-row>
        </template>
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Evaluaciones Antecedentes
        </div>
        <template v-if="perfil !== 'Validación'">
          <v-row v-if="antecedentes.length > 0">
            <v-col
              v-for="(evaluacionAntecedentes, index) in antecedentes"
              :key="index"
              cols="3"
            >
              <v-card color="secondary">
                <v-card-title
                  v-if="evaluacionAntecedentes.CatSemaforoResultado"
                  class="d-block"
                  align="center"
                >
                  <v-avatar
                    :color="evaluacionAntecedentes.CatSemaforoResultado.colorSemaforo"
                    size="48"
                    class="mb-4 blink"
                  />
                  <div class="body-2 primary--text font-weight-bold">
                    {{ evaluacionAntecedentes.CatSemaforoResultado.nombre }}
                  </div>
                </v-card-title>
                <v-card-title class="d-inline-block">
                  <div class="text-caption white--text">
                    Oficio de informe
                  </div>
                  <div class="text-h6 white--text">
                    {{ evaluacionAntecedentes.Derivacion.oficioSolicitud }}
                  </div>
                </v-card-title>
                <v-card-actions v-if="perfil === 'Antecedentes' || perfil === 'Integración'">
                  <v-spacer />
                  <v-btn
                    v-if="verifyArchivosDerivacion(evaluacionAntecedentes.Derivacion)"
                    icon
                    color="white"
                    @click="downloadArchivosDerivacion(evaluacionAntecedentes.Derivacion)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <formato-antecedentes-component :evaluacion="evaluacionAntecedentes" />
                  <v-btn
                    icon
                    color="white"
                    @click="openEvaluacionAntecedentesDialog(evaluacionAntecedentes)"
                  >
                    <v-icon>mdi-file-document</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <div class="text-h6">
                No hay informes de antecedentes registrados.
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col>
              <v-alert
                border="left"
                color="secondary"
                class="white--text"
              >
                No tiene permisos para ver esta información.
              </v-alert>
            </v-col>
          </v-row>
        </template>
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Evaluaciones Integración
        </div>
        <template v-if="perfil !== 'Antecedentes' && perfil !== 'Validación'">
          <v-row v-if="integracion.length > 0">
            <v-col
              v-for="(evaluacionIntegracion, index) in integracion"
              :key="index"
              cols="3"
            >
              <v-card color="secondary">
                <v-card-title
                  v-if="evaluacionIntegracion.CatSemaforoResultado"
                  class="d-block"
                  align="center"
                >
                  <v-avatar
                    :color="evaluacionIntegracion.CatSemaforoResultado.colorSemaforo"
                    size="48"
                    class="mb-4 blink"
                  />
                  <div class="body-2 primary--text font-weight-bold">
                    {{ evaluacionIntegracion.CatSemaforoResultado.nombre }}
                  </div>
                </v-card-title>
                <v-card-title class="d-inline-block">
                  <div class="text-caption white--text">
                    Oficio de solicitud
                  </div>
                  <div class="text-h6 white--text">
                    {{ evaluacionIntegracion.Derivacion.oficioSolicitud }}
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="text-caption white--text">
                    Acerca de la evaluación
                  </div>
                  <div class="text-body-2 white--text">
                    Evaluación realizada el {{ evaluacionIntegracion.fechaEvaluacion }}
                  </div>
                  <div class="text-caption white--text mt-4">
                    Resultado
                  </div>
                  <div class="text-body-2 white--text">
                    {{ evaluacionIntegracion.CatResultado.title }}
                  </div>
                </v-card-text>
                <v-card-actions v-if="perfil === 'Integración'">
                  <v-spacer />
                  <v-btn
                    v-if="verifyArchivosDerivacion(evaluacionIntegracion.Derivacion)"
                    icon
                    color="white"
                    @click="downloadArchivosDerivacion(evaluacionIntegracion.Derivacion)"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                  <formato-integracion-component :evaluacion="evaluacionIntegracion" />
                  <v-btn
                    icon
                    color="white"
                    @click="openResultadoIntegracionDialog(evaluacionIntegracion)"
                  >
                    <v-icon>mdi-file-document</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <div class="text-h6">
                No hay evaluaciones de integración registradas.
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col>
              <v-alert
                border="left"
                color="secondary"
                class="white--text"
              >
                No tiene permisos para ver esta información.
              </v-alert>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
    <resultado-evaluacion-medica-dialog-component
      :active="resultadoEvaluacionMedicaDialog"
      :evaluacion-medica="selectedEvaluacionMedica"
      :historia-clinica="selectedHistoriaClinica"
      @close="resultadoEvaluacionMedicaDialog = false"
    />
    <resultado-evaluacion-psicologica-dialog-component
      :active="resultadoEvaluacionPsicologicaDialog"
      :evaluacion-psicologica="selectedEvaluacionPsicologica"
      @close="resultadoEvaluacionPsicologicaDialog = false"
    />
    <resultado-evaluacion-poligrafica-dialog-component
      :active="resultadoEvaluacionPoligraficaDialog"
      :evaluacion-poligrafica="selectedEvaluacionPoligrafica"
      @close="resultadoEvaluacionPoligraficaDialog = false"
    />
    <resultado-evaluacion-validacion-dialog-component
      :active="resultadoEvaluacionValidacionDialog"
      :evaluacion-validacion="selectedEvaluacionValidacion"
      @close="resultadoEvaluacionValidacionDialog = false"
    />
    <resultado-evaluacion-ise-dialog-component
      :active="resultadoEvaluacionIseDialog"
      :evaluacion-ise="selectedEvaluacionIse"
      @close="resultadoEvaluacionIseDialog = false"
    />
    <resultado-evaluacion-antecedentes
      :active="resultadoEvaluacionAntecedentesDialog"
      :evaluacion-antecedentes="selectedEvaluacionAntecedentes"
      @close="resultadoEvaluacionAntecedentesDialog = false"
    />
    <estatus-evaluacion-ise-dialog-component
      :active="estatusEvaluacionIseDialog"
      :evaluacion-ise="selectedEvaluacionIse"
      @close="estatusEvaluacionIseDialog = false"
    />
    <resultado-integracion-dialog-component
      :active="resultadoIntegracionDialog"
      :integracion="selectedIntegracion"
      @close="resultadoIntegracionDialog = false"
    />
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ResultadoEvaluacionMedicaDialogComponent from './ResultadoEvaluacionMedicaDialogComponent.vue';
import ResultadoEvaluacionPsicologicaDialogComponent from './ResultadoEvaluacionPsicologicaDialogComponent.vue';
import ResultadoEvaluacionPoligraficaDialogComponent from './ResultadoEvaluacionPoligraficaDialogComponent.vue';
import ResultadoEvaluacionValidacionDialogComponent from './ResultadoEvaluacionValidacionDialogComponent.vue';
import ResultadoEvaluacionIseDialogComponent from './ResultadoEvaluacionIseDialogComponent.vue';
import ResultadoIntegracionDialogComponent from './ResultadoIntegracionDialogComponent.vue';
import ResultadoEvaluacionAntecedentes from './ResultadoEvaluacionAntecedentes.vue';
import EstatusEvaluacionIseDialogComponent from './EstatusEvaluacionIseDialogComponent.vue';
import FormatoPsicologicoComponent from '../../formatos/FormatoPsicologicoComponent.vue';
import FormatoPoligrafoComponent from '../../formatos/FormatoPoligrafoComponent.vue';
import FormatoMedicoComponent from '../../formatos/FormatoMedicoComponent.vue';
import FormatoIseComponent from '../../formatos/FormatoIseComponent.vue';
import FormatoValidacionComponent from '../../formatos/FormatoValidacionComponent.vue';
import FormatoAntecedentesComponent from '../../formatos/FormatoAntecedentesComponent.vue';
import FormatoIntegracionComponent from '../../formatos/FormatoIntegracionComponent.vue';

export default {
  components: {
    ResultadoEvaluacionMedicaDialogComponent,
    ResultadoEvaluacionPsicologicaDialogComponent,
    ResultadoEvaluacionPoligraficaDialogComponent,
    ResultadoEvaluacionValidacionDialogComponent,
    ResultadoEvaluacionIseDialogComponent,
    ResultadoIntegracionDialogComponent,
    ResultadoEvaluacionAntecedentes,
    EstatusEvaluacionIseDialogComponent,
    FormatoPsicologicoComponent,
    FormatoPoligrafoComponent,
    FormatoMedicoComponent,
    FormatoIseComponent,
    FormatoValidacionComponent,
    FormatoAntecedentesComponent,
    FormatoIntegracionComponent,
  },

  data() {
    return {
      resultadoEvaluacionMedicaDialog: false,
      resultadoEvaluacionPsicologicaDialog: false,
      resultadoEvaluacionPoligraficaDialog: false,
      resultadoEvaluacionValidacionDialog: false,
      resultadoEvaluacionIseDialog: false,
      resultadoEvaluacionAntecedentesDialog: false,
      resultadoIntegracionDialog: false,

      estatusEvaluacionIseDialog: false,

      selectedEvaluacionMedica: null,
      selectedHistoriaClinica: null,
      selectedEvaluacionPsicologica: null,
      selectedEvaluacionPoligrafica: null,
      selectedEvaluacionValidacion: null,
      selectedEvaluacionIse: null,
      selectedEvaluacionAntecedentes: null,
      selectedIntegracion: null,
    };
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('programacionEvaluacion', {
      programaciones: 'getProgramacionesEvaluacionesPersonal',
    }),

    ...mapGetters('evaluacionesMedico', {
      medico: 'getEvaluacionesMedico',
    }),

    ...mapGetters('historiaClinica', {
      clinica: 'getHistoriaClinica',
    }),

    ...mapGetters('evaluacionesPsicologicas', {
      psicologica: 'getEvaluacionesPsicologicas',
    }),

    ...mapGetters('evaluacionesPoligrafo', {
      poligrafica: 'getEvaluacionesPoligrafo',
    }),

    ...mapGetters('evaluacionesValidacion', {
      validacion: 'getEvaluacionesValidacion',
    }),

    ...mapGetters('evaluacionesAntecedentes', {
      antecedentes: 'getEvaluacionesAntecedentes',
    }),

    ...mapGetters('evaluacionesISE', {
      ise: 'getEvaluacionesIse',
    }),

    ...mapGetters('evaluacionesIntegracion', {
      integracion: 'getEvaluacionesIntegracion',
    }),

    ...mapGetters('seguimientoEvaluaciones', {
      seguimientos: 'getSeguimientoEvaluacion',
    }),
  },

  methods: {
    ...mapActions('accidenteLaboral', ['fetchAccidenteLaboral']),
    ...mapActions('antecedentesHeredoFamiliares', ['fetchAntecedentesHeredoFamiliares']),
    ...mapActions('ejercicio', ['fetchEjercicio']),
    ...mapActions('tipoDieta', ['fetchTipoDieta']),
    ...mapActions('vivienda', ['fetchViviendas']),
    ...mapActions('zoonosis', ['fetchZoonosis']),
    ...mapActions('medicacionActual', ['fetchMedicacionActual']),
    ...mapActions('regionExploracion', ['fetchRegionExploracion']),
    ...mapActions('antecedentesAndrogenicos', ['fetchAntecedentesAndrogenicos']),
    ...mapActions('antecedentesGinecoObstetricos', ['fetchAntecedentesGinecoObstetricos']),
    ...mapActions('patologicas', ['fetchPatologicas']),
    ...mapActions('audiciones', ['fetchAudiciones']),
    ...mapActions('antecedentesPatologicos', ['fetchAntecedentesPatologicos']),
    ...mapActions('agudezasVisuales', ['fetchAgudezasVisuales']),
    ...mapActions('interrogatorioAS', ['fetchInterrogatorioAS']),
    ...mapActions('somatometria', ['fetchSomatometria']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async openEvaluacionMedicaDialog(evaluacionMedica) {
      this.selectedEvaluacionMedica = evaluacionMedica;
      if (this.clinica.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.selectedHistoriaClinica = this.clinica[0];
        this.SET_SNACKBAR_MESSAGE('Cargando información médica.');
        await this.fetchAccidenteLaboral(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchAntecedentesHeredoFamiliares(
          this.selectedHistoriaClinica.idHistoriaClinica,
        );
        await this.fetchEjercicio(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchTipoDieta(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchViviendas(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchZoonosis(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchMedicacionActual(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchRegionExploracion(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchAntecedentesAndrogenicos(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchAntecedentesGinecoObstetricos(
          this.selectedHistoriaClinica.idHistoriaClinica,
        );
        await this.fetchAudiciones(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchAgudezasVisuales(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchInterrogatorioAS(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchAntecedentesPatologicos(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchSomatometria(this.selectedHistoriaClinica.idHistoriaClinica);
        await this.fetchPatologicas();
        this.resultadoEvaluacionMedicaDialog = true;
      } else {
        this.SET_SNACKBAR_MESSAGE('No hay historia clínica registrada.');
      }
    },

    async openEvaluacionPsicologicaDialog(evaluacion) {
      this.selectedEvaluacionPsicologica = evaluacion;
      this.resultadoEvaluacionPsicologicaDialog = true;
    },

    async openEvaluacionPoligraficaDialog(evaluacion) {
      this.selectedEvaluacionPoligrafica = evaluacion;
      this.resultadoEvaluacionPoligraficaDialog = true;
    },

    async openEvaluacionValidacionDialog(evaluacion) {
      this.selectedEvaluacionValidacion = evaluacion;
      this.resultadoEvaluacionValidacionDialog = true;
    },

    async openEvaluacionIseDialog(evaluacion) {
      this.selectedEvaluacionIse = evaluacion;
      this.resultadoEvaluacionIseDialog = true;
    },

    async openEstatusEvaluacionIseDialog(evaluacion) {
      this.selectedEvaluacionIse = evaluacion;
      this.estatusEvaluacionIseDialog = true;
    },

    async openResultadoIntegracionDialog(evaluacion) {
      this.selectedIntegracion = evaluacion;
      this.resultadoIntegracionDialog = true;
    },

    async openEvaluacionAntecedentesDialog(evaluacion) {
      this.selectedEvaluacionAntecedentes = evaluacion;
      this.resultadoEvaluacionAntecedentesDialog = true;
    },

    verifyArchivosDerivacion(derivacion) {
      if (derivacion.URLOficioSolicitud !== '' || derivacion.URLOficioRespuesta !== '') {
        return true;
      }

      return false;
    },

    downloadArchivosDerivacion(derivacion) {
      if (derivacion.URLOficioSolicitud !== '') {
        window.open(derivacion.URLOficioSolicitud, 'Download solicitud');
      }
      if (derivacion.URLOficioRespuesta !== '') {
        window.open(derivacion.URLOficioRespuesta, 'Download respuesta');
      }
    },
  },
};
</script>
<style scoped>
    .blink {
        animation: blink-animation 1s steps(5, start) infinite;
        -webkit-animation: blink-animation 1s steps(5, start) infinite;
    }

    @keyframes blink-animation {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }
    @-webkit-keyframes blink-animation {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }
</style>
